<template>
    <card>
        <template slot="header">User</template>

        <p class="mb-2">
            <span class="font-bold">{{ sum }}</span> User
        </p>
        <div v-show="group.allocation_mode !== 'fcfs'">
            <p class="mb-2">
                <span class="font-bold">{{ tenants }}</span> ohne festen Schreibtisch
            </p>
            <p class="mb-2">
                <span class="font-bold">{{ owners }}</span> mit festem Schreibtisch
            </p>
        </div>
    </card>
</template>

<script>
import Card from "./UI/Card";
import ButtonSecondary from "./UI/ButtonSecondary";

export default {
    name: "UserStatistics",
    components: {ButtonSecondary, Card},
    inject: ['group'],
    props: ['tenants', 'owners'],

    computed: {
        sum() {
            return this.tenants + this.owners;
        }
    }
}
</script>

<style scoped>

</style>
